import angular from 'angular';
import unsplashTile from '../UnsplashTile/UnsplashTile';
import config from '../../../ConfigModule/ConfigModule';
import UnsplashResource from '../UnsplashResource';
import PaginationControlsModule from '../../../PaginationControls/PaginationControlsModule';
import uiSelect from 'ui-select';
import gettext from 'angular-gettext';

export default angular.module('cms.unsplash.listing',[
    UnsplashResource,
    config,
    unsplashTile,
    PaginationControlsModule,
    uiSelect,
    gettext
]).component('cmsUnsplashListing', {
    template: require('./unsplash-listing.html'),
    bindings: {
        displayLimit: '<',
        selectable: '<',
        onSelect: '&',
        tileClass: '@',
        multiple: '<'
    },
    controller: function (UnsplashResource, $scope, gettextCatalog) {
        /** @ngInject */

        this.defaultDisplayLimit = 10;

        this.selectionData = {};

        this.availableOrders = [];

        this.selectedFilters = {
            clientOriginalName: {
                value: ''
            }
        };

        this.$onInit = () => {
            this.selectedOrder = this.availableOrders[0];
            this.currentPage = UnsplashResource.findAll({
                page: 1,
                order_by: this.selectedOrder.property,
                order_direction: this.selectedOrder.direction,
                limit: this.displayLimit || this.defaultDisplayLimit
            });
        };

        let getFilterLabels = () => {
            return [
                {
                    label: gettextCatalog.getString('upload date', null, 'As in "Sort by media upload date"'),
                    property: 'createdAt',
                    sortType: 'numeric'
                },
            ].forEach(filterGroup => {
                this.availableOrders.push({
                    group: filterGroup.label,
                    label: filterGroup.label,
                    direction: 'asc',
                    property: filterGroup.property,
                    sortType: filterGroup.sortType || 'alpha'
                });
                this.availableOrders.push({
                    group: filterGroup.label,
                    label: filterGroup.label,
                    direction: 'desc',
                    property: filterGroup.property,
                    sortType: filterGroup.sortType || 'alpha'
                });

            });
        };
        let filterLabels = getFilterLabels();
        $scope.$on('language-changed', () => {
            this.availableOrders = [];
            filterLabels = getFilterLabels();


            this.availableOrders.forEach(function (element) {
                if (element.property === this.selectedOrder.property
                    &&
                    element.direction === this.selectedOrder.direction) {
                    this.selectedOrder = element;
                }
            }, this);
        });

        this.onTileSelectionChange = (selected, media) => {
            Object.keys(this.selectionData).forEach(key => {
                if (!this.multiple && key !== media.id) {
                    delete this.selectionData[key];
                }
                if (this.multiple && key === media.id) {
                    delete this.selectionData[key];
                }
            });

            this.onSelect({media: media, selected: selected});
        };

        this.onRemoved = media => {
            let index = this.currentPage.data.indexOf(media);
            if (index > -1) {
                this.currentPage.data.splice(index, 1)
            }
        };

        this.onMediaAdded = (media) => {
            $scope.$apply(() => {
                this.currentPage.data.unshift(media);
            });
        };

        this.loadPage = page => {
            let filterValues = {};

            Object.keys(this.selectedFilters).forEach(filterProperty => {
                if (this.selectedFilters[filterProperty])
                    filterValues[filterProperty] = this.selectedFilters[filterProperty].value
            });

            this.currentPage.$cancelRequest();

            let criteria = {
                page: page,
                order_by: this.selectedOrder.property,
                order_direction: this.selectedOrder.direction,
                limit: this.displayLimit || this.defaultDisplayLimit,
            };

            this.currentPage = UnsplashResource.find(Object.assign(criteria, filterValues));

        };

        this.applyFilters = () => {
            this.currentPage.current_page = 1;
            this.loadPage(this.currentPage.current_page)
        };
    }
})
    .name;



// WEBPACK FOOTER //
// ./src/cmsCore/MediaModules/Unsplash/UnsplashListing/UnsplashListing.js